import { useMemo } from 'react';
import { convertDateToMoment } from '../util/dates';

/**
 * Custom hook to calculate hourly duration from listing data
 * @param {number} duration - Duration in days
 * @param {Array} entries - Array of time entries with startTime and endTime
 * @returns {number|null} - Hourly duration or null if not applicable
 */
export const useHourlyDuration = (duration, entries) => {
  return useMemo(
    () =>
      // If duration is 1 day, calculate the minimum entry duration in hours
      duration === 1 && entries?.length
        ? entries.reduce((hours, entry) => {
            // Get start and end times from entry
            const { startTime, endTime } = entry;

            // Split times into hours and minutes
            const [startHours, startMinutes] = startTime.split(':');
            const [endHours, endMinutes] = endTime.split(':');

            // Convert to moment objects for calculation
            const startDate = convertDateToMoment()
              .hours(startHours)
              .minutes(startMinutes);
            const endDate = convertDateToMoment(startDate)
              .hours(endHours)
              .minutes(endMinutes);

            // Calculate hours difference
            const entryInHours = endDate.diff(startDate, 'hours', true);

            // Keep the minimum hours found
            return Math.min(hours, entryInHours);
          }, 30)
        : null,
    [duration, entries]
  );
};